import { render, staticRenderFns } from "./ValvalueEdit.vue?vue&type=template&id=7b31c4e0"
import script from "./ValvalueEdit.vue?vue&type=script&lang=js"
export * from "./ValvalueEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports